// eslint-disable-next-line @townsquare/rules/no-define-messages -- Legacy defineMessages usage; migrate under TC-48428
import { defineMessages } from 'react-intl';

export const messages: {
	openInNewTabLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	projectsDirectoryNavLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	createNewProjectButtonLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	followingNavLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	statusUpdatesNavLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	archivedNavLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	openInNewTabLabel: {
		id: 'townsquare.projects-app.side-nav.open-in-new-tab',
		description:
			'Label on an external link icon for links to 0]00][0products in the side nav which will open the link in a new tab',
		defaultMessage: 'Open in new tab',
	},
	projectsDirectoryNavLabel: {
		id: 'townsquare.projects.side-nav.projects-directory',
		description: 'Side nav button to open projects directory page',
		defaultMessage: 'Project directory',
	},
	createNewProjectButtonLabel: {
		id: 'townsquare.projects.side-nav.create-project-button',
		description: 'Label for create new project button',
		defaultMessage: 'Create new project',
	},
	followingNavLabel: {
		id: 'townsquare.projects.side-nav.following-projects',
		description: 'Side nav button to open following projects page',
		defaultMessage: 'Following',
	},
	statusUpdatesNavLabel: {
		id: 'townsquare.projects.messages.status-updates',
		defaultMessage: 'Status updates',
		description: 'Side nav button to open projects updates page',
	},
	archivedNavLabel: {
		id: 'townsquare.projects.side-nav.archived-projects',
		description: 'Side nav button to open archived projects page',
		defaultMessage: 'Archived',
	},
});
